// RootStore and React context helpers (JS-only)
import { createContext, useContext, useMemo } from "react";
import { createInterviewApi } from "../services/interviewApi";
import { createInterviewLogShipper } from "../services/interviewLogShipper";
import { RecorderStore } from "./recorder.store";
import { UploaderStore } from "./uploader.store";
import { RealtimeStore } from "./realtime.store";
import { InterviewStore } from "./interview.store";
import { LogStore } from "./log.store";

const StoresContext = createContext(null);

export function RootStoreProvider({ apolloClient, children, uploadFn }) {
  const stores = useMemo(() => {
    const api = createInterviewApi({ apolloClient });
    const recorder = new RecorderStore();
    const uploader = new UploaderStore(uploadFn);
    const realtime = new RealtimeStore();
    const logStore = new LogStore();
    const logShipper = createInterviewLogShipper({ apolloClient });
    try { if (window.location.hash === "#dev") logStore.setDevMode(true); } catch { /* noop */ }
    // hook realtime logs into logStore (dev-mode display only) and into logShipper (always-on)
    realtime.service.on("log", (entry) => logStore.add(entry));
    realtime.service.on("log", (entry) => logShipper.enqueue(entry));
    const interview = new InterviewStore({ api, recorderStore: recorder, uploaderStore: uploader, realtimeStore: realtime, logShipper });
    return { api, recorder, uploader, realtime, interview, logStore, logShipper };
  }, [apolloClient, uploadFn]);

  return <StoresContext.Provider value={stores}>{children}</StoresContext.Provider>;
}

export function useStores() {
  const ctx = useContext(StoresContext);
  if (!ctx) throw new Error("useStores must be used within RootStoreProvider");
  return ctx;
}
